import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import BranchesOnMap from '../Pages/Client/BranchesOnMap';
import OrgsOnMap from '../Pages/Client/OrgsOnMap';
//server
import LoginPage from '../Pages/Server/LoginPage';
import HomePage from '../Pages/Server/HomePage';
import UpdateBranchesExcellPage from '../Pages/Server/UpdateBranchesExcellPage';
import UpdateOrgsExcellPage from '../Pages/Server/UpdateOrgsExcellPage';
import LinkGroupBranchesPages from '../Pages/Server/LinkGroupBranchesPages';
import LinkGroupOrgsPage from '../Pages/Server/LinkGroupOrgsPage';
import LinkActivitesOrgsPage from '../Pages/Server/LinkActivitesOrgsPage';
import LinkActivatesBranchesPage from '../Pages/Server/LinkActivatesBranchesPage';
import MngCategoriesPage from '../Pages/Server/MngCategoriesPage';
import ListCategoriesPage from '../Pages/Server/ListCategoriesPage';
import MngActivitiesPage from '../Pages/Server/MngActivitiesPage';
import ListActivitesPage from '../Pages/Server/ListActivitesPage';
// export const router = createBrowserRouter([
//   {
//     path: "/",
//     element: <App />,
//     children: [
//       //client
//       { path: "branches", element: <BranchesOnMap /> },
//      { path: "orgs", element: <OrgsOnMap /> },
//      //server
//       { path: "admin/login", element: <LoginPage /> },
//       { path: "admin/home", element: <HomePage /> },
//       { path: "admin/updateBranchesExll", element: <UpdateBranchesExcellPage /> },
//       { path: "admin/updateOrgsExll", element: <UpdateOrgsExcellPage /> },
//       { path: "admin/linkBranchesCategories", element: <LinkGroupBranchesPages /> },
//       { path: "admin/linkOrgsCategories", element: <LinkGroupOrgsPage /> },
//       { path: "admin/linkOrgsActivities", element: <LinkActivitesOrgsPage /> },
//       { path: "admin/linkBranchesActivities", element: <LinkActivatesBranchesPage /> },
//       //server settings 
//       { path: "admin/mngCategories", element: <MngCategoriesPage /> },
//       { path: "admin/categories", element: <ListCategoriesPage /> },
//       { path: "admin/mngActivities", element: <MngActivitiesPage /> },
//       { path: "admin/activities", element: <ListActivitesPage /> },
//     ],
//   },
// ]);



 // components/CustomerProtectedRoute.jsx
 import AdminProtectedRoute from "./AdminRoute";
import ClientProtectedRoute from "./ClientRoute";
import ListShopsPage from "../Pages/Server/ListShopsPage";
import FilterBranchesPage from "../Pages/Server/FilterBranchesPage";
import AddBranchesPage from "../Pages/Server/AddBranchesPage";
import FilterOrgsPage from "../Pages/Server/FilterOrgsPage";
import AddOrgsPage from "../Pages/Server/AddOrgsPage"; 
import MngShopsPage from "../Pages/Server/MngShopsPage";
import ListMapAccessMobilesPage from "../Pages/Server/ListMapAccessMobilesPage";
import MngAccessMobilesPage from "../Pages/Server/MngAccessMobilesPage";
export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [ 
      // client
      {
        path: "branches",
        element: <BranchesOnMap />,
      },
         {
        path: "orgs",
        element: <OrgsOnMap />,
      },
      // Login
      {
        path: "admin/login",
        element: <LoginPage />,
      },

      // Admin
      {
        path: "admin/home",
        element: (
          <AdminProtectedRoute>
            <HomePage />
          </AdminProtectedRoute>
        ),
      },
      {
        path: "admin/updateBranchesExll",
        element: (
          <AdminProtectedRoute>
            <UpdateBranchesExcellPage />
          </AdminProtectedRoute>
        ),
      },
      {
        path: "admin/updateOrgsExll",
        element: (
          <AdminProtectedRoute>
            <UpdateOrgsExcellPage />
          </AdminProtectedRoute>
        ),
      },
      {
        path: "admin/linkBranchesCategories",
        element: (
          <AdminProtectedRoute>
            <LinkGroupBranchesPages />
          </AdminProtectedRoute>
        ),
      },
 {
        path:"admin/linkOrgsCategories", 
        element: (
          <AdminProtectedRoute>
            <LinkGroupOrgsPage />
          </AdminProtectedRoute>
        ),
      },
      {
        path:"admin/linkOrgsActivities" , 
        element: (
          <AdminProtectedRoute>
            <LinkActivitesOrgsPage />
          </AdminProtectedRoute>
        ),
      },
       {
        path:"admin/linkBranchesActivities", 
        element: (
          <AdminProtectedRoute>
            <LinkActivatesBranchesPage />
          </AdminProtectedRoute>
        ),
      },
         {
        path:"admin/mngCategories", 
        element: (
          <AdminProtectedRoute>
            <MngCategoriesPage />
          </AdminProtectedRoute>
        ),
      },
           {
        path:"admin/categories",  
        element: (
          <AdminProtectedRoute>
            <ListCategoriesPage />
          </AdminProtectedRoute>
        ),
      },
          {
        path:"admin/mngActivities", 
        element: (
          <AdminProtectedRoute>
            <MngActivitiesPage />
          </AdminProtectedRoute>
        ),
      },
         {
        path:"admin/activities", 
        element: (
          <AdminProtectedRoute>
            <ListActivitesPage />
          </AdminProtectedRoute>
        ),
      },
       {
        path:"admin/listShops", 
        element: (
          <AdminProtectedRoute>
            <ListShopsPage />
          </AdminProtectedRoute>
        ),
      },
          {
        path:"admin/filterBranches", 
        element: (
          <AdminProtectedRoute>
            <FilterBranchesPage />
          </AdminProtectedRoute>
        ),
      },
         {
        path:"admin/mngBranches", 
        element: (
          <AdminProtectedRoute>
            <AddBranchesPage />
          </AdminProtectedRoute>
        ),
      },
        {
        path:"admin/filterOrgs", 
        element: (
          <AdminProtectedRoute>
            <FilterOrgsPage />
          </AdminProtectedRoute>
        ),
      }, 
        {
        path:"admin/mngOrgs", 
        element: (
          <AdminProtectedRoute>
            <AddOrgsPage />
          </AdminProtectedRoute>
        ),
      }, 
         {
        path:"admin/mngshops", 
        element: (
          <AdminProtectedRoute>
            <MngShopsPage />
          </AdminProtectedRoute>
        ),
      }, 
        {
        path:"admin/listMobiles", 
        element: (
          <AdminProtectedRoute>
            <ListMapAccessMobilesPage />
          </AdminProtectedRoute>
        ),
      },
         {
        path:"admin/mngMobiles", 
        element: (
          <AdminProtectedRoute>
            <MngAccessMobilesPage />
          </AdminProtectedRoute>
        ),
      },  
      ],
  },
]);